import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth, db } from "../firebase"; // Firebase Authentication and Firestore
import { useNavigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore"; // Firestore methods
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Button } from "./ui/button";
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  CardDescription,
  CardFooter
} from "./ui/card.jsx";


function Login() {
  const [username, setUsername] = useState(""); // Changed email to username
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      // Step 1: Look up the email associated with the username
      const usernameRef = doc(db, "usernames", username); // Access the Firestore collection
      const usernameSnapshot = await getDoc(usernameRef); // Fetch the document

      if (usernameSnapshot.exists()) {
        const userEmail = usernameSnapshot.data().email;

        // Step 2: Log in using email retrieved from Firestore and the provided password
        const userCredential = await signInWithEmailAndPassword(auth, userEmail, password);
        const user = userCredential.user;

        // Step 3: Check if the user is admin or customer based on email
        if (user.email === "admin@ev.com") {
          navigate("/admin-dashboard"); // Navigate to Admin dashboard
        } else {
          navigate("/customer-dashboard"); // Navigate to Customer dashboard
        }
      } else {
        setError("Username does not exist.");
      }
    } catch (err) {
      // Handle login errors
      setError("Failed to log in. Please check your username or password.");
    }
  };

  return (
    <div className="bg-neutral-900 flex flex-col justify-center items-center min-h-screen">
      <img src="/ev-logo.png" alt="Company Logo" className="h-20 invert mb-6" />
      <hr className="border-t-2 border-purple-600 w-32 mb-4" />
      <Card className="bg-neutral-800 border-0 w-[350px] rounded-none">
        <CardHeader>
          <CardTitle className="text-white text-4xl font-normal text-center">
            Sign In
          </CardTitle>
        </CardHeader>
        <CardContent>
          {/* Username input */}
          <div className="mb-4">
            <Label className="text-white text-base mb-2">Username</Label>
            <Input
              type="text"
              placeholder="Enter your username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="text-white border placeholder:font-normal mt-2"
            />
          </div>
          {/* Password input */}
          <div className="mb-4">
            <Label className="text-white text-base mb-2">Password</Label>
            <Input
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="text-white border placeholder:font-normal mt-2"
            />
          </div>
        </CardContent>
        <CardFooter className="flex flex-col items-center">
          {/* Submit button */}
          <Button
            type="submit"
            onClick={handleLogin}
            className="bg-purple-600 hover:bg-purple-700 text-white font-medium text-base w-full"
          >
            Sign In
          </Button>
          {error && (
            <p className="text-red-400 mt-4 font-light text-sm text-center">
              Sign In Failed. Incorrect Username or Password
            </p>
          )}
        </CardFooter>
      </Card>
    </div>
  );  
}

export default Login;
